import { render } from "./ClientEditOrderForm.vue?vue&type=template&id=f16aa2d6&scoped=true"
import script from "./ClientEditOrderForm.vue?vue&type=script&lang=js"
export * from "./ClientEditOrderForm.vue?vue&type=script&lang=js"

import "./ClientEditOrderForm.vue?vue&type=style&index=0&id=f16aa2d6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f16aa2d6"]])

export default __exports__